import { OrderStatusCategoryType } from '@src/types/graphql-types'
import messages, { Message } from '../messages'
import { messages as utilsMessages } from '@utils/messages'
import {
  OrderItemsTableStatusKey,
  OrderItemChipStatusKey,
} from '../OrderDetail/orderDetailUtils'

export const options = [
  {
    label: messages.ALL,
    value: '',
  },
  {
    label: messages.NEW,
    value: OrderStatusCategoryType.New,
  },
  {
    label: messages.IN_PROGRESS,
    value: OrderStatusCategoryType.InProgress,
  },
  {
    label: utilsMessages.ORDER_STATUS_COMPLETE,
    value: OrderStatusCategoryType.Completed,
  },
]

export enum PageInView {
  OrderPage = 'order',
  QuotesPage = 'quotes',
  AccountPage = 'account',
}

export const getStatusMessage = (
  key: OrderItemsTableStatusKey | OrderItemChipStatusKey | null
): Message | null => {
  if (key === 'ESTIMATED_TO_SHIP_ON')
    return messages.WIMS_ORDER_ITEM_SHIP_STATUS_PENDING
  if (key === 'SHIPPED_ON') return messages.WIMS_ORDER_ITEM_SHIP_STATUS_SHIPPED
  return (key && messages[key]) || null
}

export const getDateMessage = (
  key: OrderItemsTableStatusKey | OrderItemChipStatusKey | null
): Message => {
  if (key === 'ESTIMATED_TO_SHIP_ON')
    return messages.WIMS_ORDER_ITEM_SHIP_STATUS_OPEN
  if (key === 'SHIPPED_ON') return messages.SHIPPED_DATE
  return utilsMessages.UPDATED
}
